import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import DynamicHomepage from './components/DynamicHomepage';
import DynamicPage from './components/DynamicPage';
import BlogList from './components/BlogList';
import BlogPost from './components/BlogPost';
import CustomCodeInjector from './components/CustomCodeInjector';

// Admin imports
import AdminLogin from './admin/AdminLogin';
import AdminLayout from './admin/AdminLayout';
import AdminDashboard from './admin/AdminDashboard';
import MenuManager from './admin/MenuManager';
import HomepageBuilder from './admin/HomepageBuilder';
import PagesManager from './admin/PagesManager';
import PageBuilder from './admin/PageBuilder';
import FooterEditor from './admin/FooterEditor';
import BlogManager from './admin/BlogManager';
import Contacts from './admin/Contacts';
import Settings from './admin/Settings';
import RedirectsManager from './admin/RedirectsManager';

// Component to redirect non-trailing-slash URLs to trailing-slash versions (public pages only)
const TrailingSlashRedirect = () => {
  const location = useLocation();
  const { pathname, search, hash } = location;
  
  // Skip admin routes and homepage
  if (pathname === '/' || pathname.startsWith('/admin')) {
    return null;
  }
  
  // If path doesn't end with slash, redirect to version with slash
  if (!pathname.endsWith('/')) {
    return <Navigate to={`${pathname}/${search}${hash}`} replace />;
  }
  
  return null;
};

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <CustomCodeInjector />
        <BrowserRouter>
          <TrailingSlashRedirect />
          <Routes>
            <Route path="/" element={<DynamicHomepage />} />
            
            {/* Blog Routes */}
            <Route path="/blog/" element={<BlogList />} />
            <Route path="/blog/:slug/" element={<BlogPost />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="menu" element={<MenuManager />} />
              <Route path="menus" element={<MenuManager />} />
              <Route path="homepage" element={<HomepageBuilder />} />
              <Route path="pages" element={<PagesManager />} />
              <Route path="pages/:pageId/builder" element={<PageBuilder />} />
              <Route path="footer" element={<FooterEditor />} />
              <Route path="blog" element={<BlogManager />} />
              <Route path="contacts" element={<Contacts />} />
              <Route path="redirects" element={<RedirectsManager />} />
              <Route path="settings" element={<Settings />} />
            </Route>
            
            {/* Dynamic Page Routes - with trailing slash */}
            <Route path="/:slug/" element={<DynamicPage />} />
            {/* Also match without trailing slash and redirect */}
            <Route path="/:slug" element={<DynamicPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
}

export default App;